import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductionRoutingModule } from './production-routing.module';
import { ProductionListComponent } from './production-list/production-list.component';
import { ProductionJobCreationComponent } from './production-job-creation/production-job-creation.component';
import { CreateProductionJobComponent } from './create-production-job/create-production-job.component';
import { StageConfigComponent } from './stage-config/stage-config.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobDetailsComponent } from './job-details/job-details.component';
import { ProductionOutputComponent } from './production-output/production-output.component';
import { ProcessStagesComponent } from './process-stages/process-stages.component'; 
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatPaginatorModule } from '@angular/material/paginator';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ReportComponent } from './report/report.component';
import {InventoryModule} from '../inventory/inventory.module';
import { MaterialConsumptionComponent } from './material-consumption/material-consumption.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RejectionsReasonsConfigComponent } from './rejections-reasons-config/rejections-reasons-config.component';
import { SettingsComponent } from './settings/settings.component';
import { PipeModuleModule } from '../pipe/pipe-module/pipe-module.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ExpenseConfigComponent } from './expense-config/expense-config.component';
import { EnterExpenseComponent } from './enter-expense/enter-expense.component';
import { EnterStageComponent } from './enter-stage/enter-stage.component';
import { StageTasksListComponent } from './stage-tasks-list/stage-tasks-list.component';


@NgModule({
  declarations: [
    ProductionListComponent, 
    ProductionJobCreationComponent, 
    CreateProductionJobComponent, 
    StageConfigComponent, 
    JobDetailsComponent, 
    ProductionOutputComponent, 
    ProcessStagesComponent, 
    ReportComponent, 
    MaterialConsumptionComponent,
    RejectionsReasonsConfigComponent,
    SettingsComponent,
    ExpenseConfigComponent,
    EnterExpenseComponent,
    EnterStageComponent,
    StageTasksListComponent
  ],
  imports: [
    CommonModule,
      ProductionRoutingModule,
      ReactiveFormsModule,
      FormsModule,
      MatAutocompleteModule, 
      MatFormFieldModule,
      MatTableModule,
      MatSelectModule,
      MatInputModule,
      MatDatepickerModule,
      MatNativeDateModule,
      ReactiveFormsModule,
      MatPaginatorModule,
      MatCheckboxModule,
      InventoryModule,
      DragDropModule,
      PipeModuleModule,
      NgxSpinnerModule 
   ],
  exports:[
    MatPaginatorModule,
    
  ],
  providers:[
    NgbActiveModal
  ],
  
  entryComponents: [CreateProductionJobComponent, ProductionJobCreationComponent, MaterialConsumptionComponent, EnterStageComponent, StageTasksListComponent]
})
export class ProductionModule { }
